// Format last active date in Norwegian
export function formatLastActive(lastActiveDate: string | null | undefined): string {
  if (!lastActiveDate) return 'Aldri aktiv';

  const now = new Date();
  const lastActive = new Date(lastActiveDate);
  const diffMs = now.getTime() - lastActive.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);

  if (diffMinutes < 5) {
    return 'Aktiv nå';
  } else if (diffMinutes < 60) {
    return `Aktiv for ${diffMinutes} min siden`;
  } else if (diffHours < 24) {
    return diffHours === 1 ? 'Aktiv for 1 time siden' : `Aktiv for ${diffHours} timer siden`;
  } else if (diffDays === 1) {
    return 'Aktiv i går';
  } else if (diffDays < 7) {
    return `Aktiv for ${diffDays} dager siden`;
  } else if (diffWeeks < 4) {
    return diffWeeks === 1 ? 'Aktiv for 1 uke siden' : `Aktiv for ${diffWeeks} uker siden`;
  } else if (diffMonths < 6) {
    return diffMonths === 1 ? 'Aktiv for 1 måned siden' : `Aktiv for ${diffMonths} måneder siden`;
  } else {
    return 'Inaktiv';
  }
}

// Format distance to now in Norwegian (for admin dashboard)
export function formatDistanceToNow(dateString: string | null | undefined): string {
  if (!dateString) return 'Ukjent';

  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now.getTime() - date.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  if (diffMinutes < 1) {
    return 'Nå';
  } else if (diffMinutes < 60) {
    return `${diffMinutes} min siden`;
  } else if (diffHours < 24) {
    return diffHours === 1 ? '1 time siden' : `${diffHours} timer siden`;
  } else if (diffDays === 1) {
    return 'I går';
  } else if (diffDays < 7) {
    return `${diffDays} dager siden`;
  } else if (diffWeeks < 4) {
    return diffWeeks === 1 ? '1 uke siden' : `${diffWeeks} uker siden`;
  } else if (diffMonths < 12) {
    return diffMonths === 1 ? '1 måned siden' : `${diffMonths} måneder siden`;
  } else {
    return diffYears === 1 ? '1 år siden' : `${diffYears} år siden`;
  }
}